export const LIBRARY_LIST_LOADING = "LIBRARY_LIST_LOADING";
export const LIBRARY_LIST_SUCCESS = "LIBRARY_LIST_SUCCESS";
export const LIBRARY_LIST_ERROR = "LIBRARY_LIST_ERROR";

export const LIBRARY_PLAYLIST_LOADING = "LIBRARY_PLAYLIST_LOADING";
export const LIBRARY_PLAYLIST_SUCCESS = "LIBRARY_PLAYLIST_SUCCESS";
export const LIBRARY_PLAYLIST_ERROR = "LIBRARY_PLAYLIST_ERROR";
